import { useAuth } from "../../common/contexts/AuthContext";
import { usePopup } from "../../common/contexts/PopupContext";
import UserDetailsForm from "../components/UserDetailsForm";
import { useMutation } from "react-query";
import useUser from "../../common/hooks/pages/useUser";
import { useApp } from "../../common/contexts/AppContext";

function ProfileContainer() {
  const { user, fetchProfile } = useAuth();

  const { isOwner } = useApp();

  const { toast } = usePopup();

  const { updateUser } = useUser();

  const { mutate: userUpdate, isLoading } = useMutation({
    mutationFn: updateUser,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      fetchProfile();

      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating user!";
      toast(message, "error");
    },
  });

  return (
    <UserDetailsForm
      user={user}
      userUpdate={userUpdate}
      isLoading={isLoading}
      isOwner={isOwner}
    />
  );
}

export default ProfileContainer;
